export { SupportPage } from './lib/support-page'

export { getStaticProps } from './lib/get-static-props'
